import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import{TripDriverLinkContainerModel} from '../../../../../../../models/aggregates/erp/delivery/trip-driver-link/trip-delivery-hdr-container.model';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../../shared';


@Injectable({
  providedIn: 'root'
})
export class TripDriverLinkService extends BaseApiTemplateService<TripDriverLinkContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/drivers
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trip-driver-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trip-driver-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/trip-driver-links/backoffice-ep';
    this.httpClient = http;
  }
}